import { useState, useContext } from 'react'
import fetch from 'node-fetch'
import { getShopifyLanguage } from '../components/CurrencyConverterSwitcher'
import { useShopify } from '../contexts/shopify'
import { LayoutContext } from '../contexts'

const useProductTitleTranslation = () => {
  const { storeSubdomain } = useContext(LayoutContext)
  const { stores } = useShopify()
  const [state, setState] = useState({
    title: null,
    loading: false,
    error: null,
  })

  const getProductTitleTranslation = async (lineItemId, node_locale) => {
    const store = stores[storeSubdomain]
    const language = getShopifyLanguage(node_locale)
    const storefrontAccessToken = store.storefrontAccessToken
    const url = `https://${store.customDomain}/api/2020-04/graphql.json`
    // const url = `https://${store.subdomain}.myshopify.com/api/2020-04/graphql.json`
    const query = `
       query translatedProductVariant($id: ID!) {
        node(id: $id) {
          ... on CheckoutLineItem {
            variant {
              product {
                title
              }
            }
          }
        }
      }
    `

    setState({
      title: null,
      loading: true,
      error: null,
    })
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          'Accept-Language': language,
        },
        body: JSON.stringify({
          query,
          variables: {
            id: lineItemId,
          },
        }),
      })
      const {
        data: {
          node: {
            variant: {
              product: { title },
            },
          },
        },
      } = await response.json()
      setState({ title, loading: 'completed', error: null })
    } catch (error) {
      setState({ title: null, loading: 'completed', error })
    }
  }

  return [getProductTitleTranslation, state]
}

export default useProductTitleTranslation
